import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import React from 'react';
import { IconUiClose } from '../';
var styles = {
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: 1,
    borderColor: 'grey.6',
    height: '53px',
    padding: 3
  },
  closeButton: {
    cursor: 'pointer',
    padding: 1,
    display: 'flex',
    background: 'transparent',
    border: 'none',
    outline: 'none'
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    marginRight: 3,
    display: 'flex'
  },
  iconClickable: {
    cursor: 'pointer'
  }
};
var ModalHeader = function ModalHeader(_ref) {
  var icon = _ref.icon,
    onClose = _ref.onClose,
    title = _ref.title,
    _ref$closeDescription = _ref.closeDescription,
    closeDescription = _ref$closeDescription === void 0 ? 'Close' : _ref$closeDescription;
  return jsx("div", {
    sx: styles.headerContainer
  }, jsx("div", {
    sx: styles.headerLeft
  }, icon && /*#__PURE__*/React.cloneElement(icon, {
    sx: _objectSpread(_objectSpread({}, styles.icon), icon.props.onClick && styles.iconClickable)
  }), title && jsx("span", null, title)), onClose && jsx("button", {
    "aria-label": closeDescription,
    onClick: onClose,
    sx: styles.closeButton
  }, jsx(IconUiClose, {
    size: "xsmall"
  })));
};
export { ModalHeader };